"use client";
import React from 'react';
import './Accordeon.css';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg';

const Accordeon = ({title, children}) => {
	const [open, setOpen] = useState(false);

	return (
		<div className='accordeon w-full px-7 py-5 border-b-[2px] border-red flex flex-col justify-between'>
			<div className='flex flex-row justify-between items-center hover:cursor-pointer text-lg font-light' onClick={() => setOpen(!open)}>
				{title}
				<div  className='cursor-pointer'>
					{<ArrowDown width={20} className={`${open ? 'rotate-180 transition-all duration-500' : 'rotate-0 transition-all duration-500'}`}/>}
				</div>
			</div>
			{open && 
				<div className='mt-5 text-md font-light '>
					{children}
				</div>
			}
 		</div>
	);
};

Accordeon.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node
};

export default Accordeon;